import Backbone from 'vendor/backbone';

export default Backbone;



// WEBPACK FOOTER //
// ./app/common/vendor/backbone.js